import { template as template_0902f160de074a319db9b34220b23b56 } from "@ember/template-compiler";
import { t } from 'ember-intl';
export default template_0902f160de074a319db9b34220b23b56(`
<div
  class="total-cycles-label-wrapper component-bi-total-cycles-label"
  ...attributes
>
  <h1>
    <span class="label">
      {{t "reporting.totalparts"}}:
    </span>
    <span class="total-cycles">
      {{@total}}
    </span>
    <span class="total-rejects pe-0">
      {{@rejectCount}}
    </span>
  </h1>
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
